// @/utils/gradio-index.js
 const host = window.location.hostname
// const host = "http://en.dw678.xyz"
//
let exportMod

// 同步返回Promise，组件可以await或.then
if (host.indexOf("en")!=-1) {
    exportMod = import("./gradio1")
}else{
    exportMod = import("./gradio")
}

export default exportMod